import {
  REACT_APP_EMR_COMPONENT_HANDLE,
  REACT_APP_ON_CALL_PROVIDERS_COMPONENT_HANDLE,
  REACT_APP_SUPPORT_COMPONENT_HANDLE,
  REACT_APP_VOICESENSE_COMPONENT_HANDLE
} from "../../env";

// clean selected add-on data before it goes into selected add-on state
export const formatSelection = (addOn, quantity) => ({
  id: addOn.id,
  name: addOn.name,
  handle: addOn.handle,
  quantity,
});

// fetch useEffect helper
// don't show certain components
// don't show certain components if their cost is zero
export const processReferralComponents = (components, pricePoints = []) => {
  const handles = {
    onCall: REACT_APP_ON_CALL_PROVIDERS_COMPONENT_HANDLE,
    emr: REACT_APP_EMR_COMPONENT_HANDLE,
    addOns: [
      REACT_APP_SUPPORT_COMPONENT_HANDLE,
      REACT_APP_VOICESENSE_COMPONENT_HANDLE,
      REACT_APP_EMR_COMPONENT_HANDLE,
      REACT_APP_ON_CALL_PROVIDERS_COMPONENT_HANDLE,
    ],
  };

  // Pre-index pricePoints by componentId to keep logic linear O(components + pricePoints)
  const pricePointMap = pricePoints.reduce((acc, pp) => {
    const existing = acc[pp.componentId];
    if (!existing || pp.default) {
      acc[pp.componentId] = pp;
    }
    return acc;
  }, {});

  const categorized = components.reduce((acc, component) => {
    const handle = component.metadata.handle;
    let cost = parseFloat(component.metadata.unit_price || 0);

    // Check if there is a price point override in the referral data
    const pricePoint = pricePointMap[component.id];
    if (pricePoint && pricePoint.prices && pricePoint.prices.length > 0) {
      cost = parseFloat(pricePoint.prices[0].unitPrice || 0);
    }

    // Always include on-call-providers and EMR, even if cost is 0
    // Skip other components if cost is 0
    if (cost === 0 && handle !== handles.emr && handle !== handles.onCall) return acc;

    const addOn = {
      id: component.id,
      name: component.name,
      description: component.description,
      cost: cost,
      quantity: 0,
      kind: component.kind,
      handle: handle,
    };

    if (handles.addOns.includes(handle)) {
      acc.addOns.push(addOn);
    }

    return acc;
  }, {
    addOns: [],
  });

  const onCallAddOn = categorized.addOns.find(a => a.handle === handles.onCall);
  const licensingFee = !!(onCallAddOn && onCallAddOn.cost > 0);

  return {
    addOns: categorized.addOns,
    licensingFee,
  };
};

// Track estimated total
export const calculateEstimatedTotal = (selectedAddOns, addOns) => {
  const addOnMap = addOns.reduce((acc, addOn) => {
    acc[addOn.id] = addOn;
    return acc;
  }, {});

  return selectedAddOns.reduce((acc, selectedAddOn) => {
    const addOn = addOnMap[selectedAddOn.id];
    const cost = (addOn && addOn.cost) ? addOn.cost : 0;
    const quantity = selectedAddOn.quantity;
    return acc + (cost * quantity);
  }, 0);
};

export const formatPhoneNumber = (value) => {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, '');
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};
